module.exports = __webpack_public_path__ + "static/img/6_fun_1205.0fcc076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/6_fun_1205.png
// module id = JYHY
// module chunks = 0